'use strict';

module.exports = [
  {
    number: 1,
    isotopes: [
      { nominal: 1, mass: 1.00782503223, abundance: 0.999885 },
      { nominal: 2, mass: 2.01410177812, abundance: 0.000115 },
    ],
    symbol: 'H',
    mass: 1.0079407540557772,
    name: 'Hydrogen',
    monoisotopicMass: 1.00782503223,
  },
  {
    number: 2,
    isotopes: [
      { nominal: 3, mass: 3.0160293201, abundance: 0.00000134 },
      { nominal: 4, mass: 4.00260325413, abundance: 0.99999866 },
    ],
    symbol: 'He',
    mass: 4.002601932120929,
    name: 'Helium',
    monoisotopicMass: 4.00260325413,
  },
  {
    number: 3,
    isotopes: [
      { nominal: 6, mass: 6.0151228874, abundance: 0.0759 },
      { nominal: 7, mass: 7.0160034366, abundance: 0.9241 },
    ],
    symbol: 'Li',
    mass: 6.94003660291572,
    name: 'Lithium',
    monoisotopicMass: 7.0160034366,
  },
  {
    number: 4,
    isotopes: [{ nominal: 9, mass: 9.012183065, abundance: 1 }],
    symbol: 'Be',
    mass: 9.012183065,
    name: 'Beryllium',
    monoisotopicMass: 9.012183065,
  },
  {
    number: 5,
    isotopes: [
      { nominal: 10, mass: 10.01293695, abundance: 0.199 },
      { nominal: 11, mass: 11.00930536, abundance: 0.801 },
    ],
    symbol: 'B',
    mass: 10.811028046410001,
    name: 'Boron',
    monoisotopicMass: 11.00930536,
  },
  {
    number: 6,
    isotopes: [
      { nominal: 12, mass: 12, abundance: 0.9893 },
      { nominal: 13, mass: 13.00335483507, abundance: 0.0107 },
    ],
    symbol: 'C',
    mass: 12.010735896735248,
    name: 'Carbon',
    monoisotopicMass: 12,
  },
  {
    number: 7,
    isotopes: [
      { nominal: 14, mass: 14.00307400443, abundance: 0.99636 },
      { nominal: 15, mass: 15.00010889888, abundance: 0.00364 },
    ],
    symbol: 'N',
    mass: 14.006703211445798,
    name: 'Nitrogen',
    monoisotopicMass: 14.00307400443,
  },
  {
    number: 8,
    isotopes: [
      { nominal: 16, mass: 15.99491461957, abundance: 0.99757 },
      { nominal: 17, mass: 16.9991317565, abundance: 0.00038 },
      { nominal: 18, mass: 17.99915961286, abundance: 0.00205 },
    ],
    symbol: 'O',
    mass: 15.999404924318277,
    name: 'Oxygen',
    monoisotopicMass: 15.99491461957,
  },
  {
    number: 9,
    isotopes: [{ nominal: 19, mass: 18.99840316273, abundance: 1 }],
    symbol: 'F',
    mass: 18.99840316273,
    name: 'Fluorine',
    monoisotopicMass: 18.99840316273,
  },
  {
    number: 10,
    isotopes: [
      { nominal: 20, mass: 19.9924401762, abundance: 0.9048 },
      { nominal: 21, mass: 20.993846685, abundance: 0.0027 },
      { nominal: 22, mass: 21.991385114, abundance: 0.0925 },
    ],
    symbol: 'Ne',
    mass: 20.18004638052026,
    name: 'Neon',
    monoisotopicMass: 19.9924401762,
  },
  {
    number: 11,
    isotopes: [{ nominal: 23, mass: 22.989769282, abundance: 1 }],
    symbol: 'Na',
    mass: 22.989769282,
    name: 'Sodium',
    monoisotopicMass: 22.989769282,
  },
  {
    number: 12,
    isotopes: [
      { nominal: 24, mass: 23.985041697, abundance: 0.7899 },
      { nominal: 25, mass: 24.985836976, abundance: 0.1 },
      { nominal: 26, mass: 25.982592968, abundance: 0.1101 },
    ],
    symbol: 'Mg',
    mass: 24.3050516198371,
    name: 'Magnesium',
    monoisotopicMass: 23.985041697,
  },
  {
    number: 13,
    isotopes: [{ nominal: 27, mass: 26.98153853, abundance: 1 }],
    symbol: 'Al',
    mass: 26.98153853,
    name: 'Aluminium',
    monoisotopicMass: 26.98153853,
  },
  {
    number: 14,
    isotopes: [
      { nominal: 28, mass: 27.97692653465, abundance: 0.92223 },
      { nominal: 29, mass: 28.9764946649, abundance: 0.04685 },
      { nominal: 30, mass: 29.973770136, abundance: 0.03092 },
    ],
    symbol: 'Si',
    mass: 28.085498705705955,
    name: 'Silicon',
    monoisotopicMass: 27.97692653465,
  },
  {
    number: 15,
    isotopes: [{ nominal: 31, mass: 30.97376199842, abundance: 1 }],
    symbol: 'P',
    mass: 30.97376199842,
    name: 'Phosphorus',
    monoisotopicMass: 30.97376199842,
  },
  {
    number: 16,
    isotopes: [
      { nominal: 32, mass: 31.9720711744, abundance: 0.9499 },
      { nominal: 33, mass: 32.9714589098, abundance: 0.0075 },
      { nominal: 34, mass: 33.967867004, abundance: 0.0425 },
      { nominal: 36, mass: 35.96708071, abundance: 0.0001 },
    ],
    symbol: 'S',
    mass: 32.06478740612706,
    name: 'Sulfur',
    monoisotopicMass: 31.9720711744,
  },
  {
    number: 17,
    isotopes: [
      { nominal: 35, mass: 34.968852682, abundance: 0.7576 },
      { nominal: 37, mass: 36.965902602, abundance: 0.2424 },
    ],
    symbol: 'Cl',
    mass: 35.452937582608,
    name: 'Chlorine',
    monoisotopicMass: 34.968852682,
  },
  {
    number: 18,
    isotopes: [
      { nominal: 36, mass: 35.967545105, abundance: 0.003336 },
      { nominal: 38, mass: 37.96273211, abundance: 0.000629 },
      { nominal: 40, mass: 39.9623831237, abundance: 0.996035 },
    ],
    symbol: 'Ar',
    mass: 39.947798563582005,
    name: 'Argon',
    monoisotopicMass: 39.9623831237,
  },
  {
    number: 19,
    isotopes: [
      { nominal: 39, mass: 38.9637064864, abundance: 0.932581 },
      { nominal: 40, mass: 39.963998166, abundance: 0.000117 },
      { nominal: 41, mass: 40.9618252579, abundance: 0.067302 },
    ],
    symbol: 'K',
    mass: 39.098300910086,
    name: 'Potassium',
    monoisotopicMass: 38.9637064864,
  },
  {
    number: 20,
    isotopes: [
      { nominal: 40, mass: 39.962590863, abundance: 0.96941 },
      { nominal: 42, mass: 41.95861783, abundance: 0.00647 },
      { nominal: 43, mass: 42.95876644, abundance: 0.00135 },
      { nominal: 44, mass: 43.95548156, abundance: 0.02086 },
      { nominal: 46, mass: 45.953689, abundance: 0.00004 },
      { nominal: 48, mass: 47.95252276, abundance: 0.00187 },
    ],
    symbol: 'Ca',
    mass: 40.078022511017735,
    name: 'Calcium',
    monoisotopicMass: 39.962590863,
  },
  {
    number: 21,
    isotopes: [{ nominal: 45, mass: 44.95590828, abundance: 1 }],
    symbol: 'Sc',
    mass: 44.95590828,
    name: 'Scandium',
    monoisotopicMass: 44.95590828,
  },
  {
    number: 22,
    isotopes: [
      { nominal: 46, mass: 45.95262772, abundance: 0.0825 },
      { nominal: 47, mass: 46.95175879, abundance: 0.0744 },
      { nominal: 48, mass: 47.94794198, abundance: 0.7372 },
      { nominal: 49, mass: 48.94786568, abundance: 0.0541 },
      { nominal: 50, mass: 49.94478689, abundance: 0.0518 },
    ],
    symbol: 'Ti',
    mass: 47.866744962721995,
    name: 'Titanium',
    monoisotopicMass: 47.94794198,
  },
  {
    number: 23,
    isotopes: [
      { nominal: 50, mass: 49.94715601, abundance: 0.0025 },
      { nominal: 51, mass: 50.94395704, abundance: 0.9975 },
    ],
    symbol: 'V',
    mass: 50.941465037425004,
    name: 'Vanadium',
    monoisotopicMass: 50.94395704,
  },
  {
    number: 24,
    isotopes: [
      { nominal: 50, mass: 49.94604183, abundance: 0.04345 },
      { nominal: 52, mass: 51.94050623, abundance: 0.83789 },
      { nominal: 53, mass: 52.94064815, abundance: 0.09501 },
      { nominal: 54, mass: 53.93887916, abundance: 0.02365 },
    ],
    symbol: 'Cr',
    mass: 51.9961317554337,
    name: 'Chromium',
    monoisotopicMass: 51.94050623,
  },
  {
    number: 25,
    isotopes: [{ nominal: 55, mass: 54.93804391, abundance: 1 }],
    symbol: 'Mn',
    mass: 54.93804391,
    name: 'Manganese',
    monoisotopicMass: 54.93804391,
  },
  {
    number: 26,
    isotopes: [
      { nominal: 54, mass: 53.93960899, abundance: 0.05845 },
      { nominal: 56, mass: 55.93493633, abundance: 0.91754 },
      { nominal: 57, mass: 56.93539284, abundance: 0.02119 },
      { nominal: 58, mass: 57.93327443, abundance: 0.00282 },
    ],
    symbol: 'Fe',
    mass: 55.845144433865904,
    name: 'Iron',
    monoisotopicMass: 55.93493633,
  },
  {
    number: 27,
    isotopes: [{ nominal: 59, mass: 58.93319429, abundance: 1 }],
    symbol: 'Co',
    mass: 58.93319429,
    name: 'Cobalt',
    monoisotopicMass: 58.93319429,
  },
  {
    number: 28,
    isotopes: [
      { nominal: 58, mass: 57.93534241, abundance: 0.68077 },
      { nominal: 60, mass: 59.93078588, abundance: 0.26223 },
      { nominal: 61, mass: 60.93105557, abundance: 0.011399 },
      { nominal: 62, mass: 61.92834537, abundance: 0.036346 },
      { nominal: 64, mass: 63.92796682, abundance: 0.009255 },
    ],
    symbol: 'Ni',
    mass: 58.69334710994765,
    name: 'Nickel',
    monoisotopicMass: 57.93534241,
  },
  {
    number: 29,
    isotopes: [
      { nominal: 63, mass: 62.92959772, abundance: 0.6915 },
      { nominal: 65, mass: 64.9277897, abundance: 0.3085 },
    ],
    symbol: 'Cu',
    mass: 63.54603994583,
    name: 'Copper',
    monoisotopicMass: 62.92959772,
  },
  {
    number: 30,
    isotopes: [
      { nominal: 64, mass: 63.92914201, abundance: 0.4917 },
      { nominal: 66, mass: 65.92603381, abundance: 0.2773 },
      { nominal: 67, mass: 66.92712775, abundance: 0.0404 },
      { nominal: 68, mass: 67.92484455, abundance: 0.1845 },
      { nominal: 70, mass: 69.9253192, abundance: 0.0061 },
    ],
    symbol: 'Zn',
    mass: 65.37778252952499,
    name: 'Zinc',
    monoisotopicMass: 63.92914201,
  },
  {
    number: 31,
    isotopes: [
      { nominal: 69, mass: 68.9255735, abundance: 0.60108 },
      { nominal: 71, mass: 70.92470258, abundance: 0.39892 },
    ],
    symbol: 'Ga',
    mass: 69.7230660725936,
    name: 'Gallium',
    monoisotopicMass: 68.9255735,
  },
  {
    number: 32,
    isotopes: [
      { nominal: 70, mass: 69.92424875, abundance: 0.2057 },
      { nominal: 72, mass: 71.922075826, abundance: 0.2745 },
      { nominal: 73, mass: 72.923458956, abundance: 0.0775 },
      { nominal: 74, mass: 73.921177761, abundance: 0.365 },
      { nominal: 76, mass: 75.921402726, abundance: 0.0773 },
    ],
    symbol: 'Ge',
    mass: 72.6275501646868,
    name: 'Germanium',
    monoisotopicMass: 73.921177761,
  },
  {
    number: 33,
    isotopes: [{ nominal: 75, mass: 74.92159457, abundance: 1 }],
    symbol: 'As',
    mass: 74.92159457,
    name: 'Arsenic',
    monoisotopicMass: 74.92159457,
  },
  {
    number: 34,
    isotopes: [
      { nominal: 74, mass: 73.922475934, abundance: 0.0089 },
      { nominal: 76, mass: 75.919213704, abundance: 0.0937 },
      { nominal: 77, mass: 76.919914154, abundance: 0.0763 },
      { nominal: 78, mass: 77.91730928, abundance: 0.2377 },
      { nominal: 80, mass: 79.9165218, abundance: 0.4961 },
      { nominal: 82, mass: 81.9166995, abundance: 0.0873 },
    ],
    symbol: 'Se',
    mass: 78.95938855701361,
    name: 'Selenium',
    monoisotopicMass: 79.9165218,
  },
  {
    number: 35,
    isotopes: [
      { nominal: 79, mass: 78.9183376, abundance: 0.5069 },
      { nominal: 81, mass: 80.9162897, abundance: 0.4931 },
    ],
    symbol: 'Br',
    mass: 79.90352778050999,
    name: 'Bromine',
    monoisotopicMass: 78.9183376,
  },
  {
    number: 36,
    isotopes: [
      { nominal: 78, mass: 77.92036494, abundance: 0.00355 },
      { nominal: 80, mass: 79.91637808, abundance: 0.02286 },
      { nominal: 82, mass: 81.91348273, abundance: 0.11593 },
      { nominal: 83, mass: 82.91412716, abundance: 0.115 },
      { nominal: 84, mass: 83.9114977282, abundance: 0.56987 },
      { nominal: 86, mass: 85.9106106269, abundance: 0.17279 },
    ],
    symbol: 'Kr',
    mass: 83.7979999953261,
    name: 'Krypton',
    monoisotopicMass: 83.9114977282,
  },
  {
    number: 37,
    isotopes: [
      { nominal: 85, mass: 84.9117897379, abundance: 0.7217 },
      { nominal: 87, mass: 86.909180531, abundance: 0.2783 },
    ],
    symbol: 'Rb',
    mass: 85.46766359561973,
    name: 'Rubidium',
    monoisotopicMass: 84.9117897379,
  },
  {
    number: 38,
    isotopes: [
      { nominal: 84, mass: 83.9134191, abundance: 0.0056 },
      { nominal: 86, mass: 85.9092606, abundance: 0.0986 },
      { nominal: 87, mass: 86.9088775, abundance: 0.07 },
      { nominal: 88, mass: 87.9056125, abundance: 0.8258 },
    ],
    symbol: 'Sr',
    mass: 87.61664446962,
    name: 'Strontium',
    monoisotopicMass: 87.9056125,
  },
  {
    number: 39,
    isotopes: [{ nominal: 89, mass: 88.9058403, abundance: 1 }],
    symbol: 'Y',
    mass: 88.9058403,
    name: 'Yttrium',
    monoisotopicMass: 88.9058403,
  },
  {
    number: 40,
    isotopes: [
      { nominal: 90, mass: 89.9046977, abundance: 0.5145 },
      { nominal: 91, mass: 90.9056396, abundance: 0.1122 },
      { nominal: 92, mass: 91.9050347, abundance: 0.1715 },
      { nominal: 94, mass: 93.9063108, abundance: 0.1738 },
      { nominal: 96, mass: 95.9082714, abundance: 0.028 },
    ],
    symbol: 'Zr',
    mass: 91.22364159706,
    name: 'Zirconium',
    monoisotopicMass: 89.9046977,
  },
  {
    number: 41,
    isotopes: [{ nominal: 93, mass: 92.906373, abundance: 1 }],
    symbol: 'Nb',
    mass: 92.906373,
    name: 'Niobium',
    monoisotopicMass: 92.906373,
  },
  {
    number: 42,
    isotopes: [
      { nominal: 92, mass: 91.90680796, abundance: 0.1453 },
      { nominal: 94, mass: 93.9050849, abundance: 0.0915 },
      { nominal: 95, mass: 94.90583877, abundance: 0.1584 },
      { nominal: 96, mass: 95.90467612, abundance: 0.1667 },
      { nominal: 97, mass: 96.90601812, abundance: 0.096 },
      { nominal: 98, mass: 97.90540482, abundance: 0.2439 },
      { nominal: 100, mass: 99.9074718, abundance: 0.0982 },
    ],
    symbol: 'Mo',
    mass: 95.959788541188,
    name: 'Molybdenum',
    monoisotopicMass: 97.90540482,
  },
  { number: 43, isotopes: [], symbol: 'Tc', mass: null, name: 'Technetium' },
  {
    number: 44,
    isotopes: [
      { nominal: 96, mass: 95.90759025, abundance: 0.0554 },
      { nominal: 98, mass: 97.9052868, abundance: 0.0187 },
      { nominal: 99, mass: 98.9059341, abundance: 0.1276 },
      { nominal: 100, mass: 99.9042143, abundance: 0.126 },
      { nominal: 101, mass: 100.9055769, abundance: 0.1706 },
      { nominal: 102, mass: 101.9043441, abundance: 0.3155 },
      { nominal: 104, mass: 103.9054275, abundance: 0.1862 },
    ],
    symbol: 'Ru',
    mass: 101.06494013916,
    name: 'Ruthenium',
    monoisotopicMass: 101.9043441,
  },
  {
    number: 45,
    isotopes: [{ nominal: 103, mass: 102.905498, abundance: 1 }],
    symbol: 'Rh',
    mass: 102.905498,
    name: 'Rhodium',
    monoisotopicMass: 102.905498,
  },
  {
    number: 46,
    isotopes: [
      { nominal: 102, mass: 101.9056022, abundance: 0.0102 },
      { nominal: 104, mass: 103.9040305, abundance: 0.1114 },
      { nominal: 105, mass: 104.9050796, abundance: 0.2233 },
      { nominal: 106, mass: 105.9034804, abundance: 0.2733 },
      { nominal: 108, mass: 107.9038916, abundance: 0.2646 },
      { nominal: 110, mass: 109.9051722, abundance: 0.1172 },
    ],
    symbol: 'Pd',
    mass: 106.41532750734,
    name: 'Palladium',
    monoisotopicMass: 105.9034804,
  },
  {
    number: 47,
    isotopes: [
      { nominal: 107, mass: 106.9050916, abundance: 0.51839 },
      { nominal: 109, mass: 108.9047553, abundance: 0.48161 },
    ],
    symbol: 'Ag',
    mass: 107.868149634557,
    name: 'Silver',
    monoisotopicMass: 106.9050916,
  },
  {
    number: 48,
    isotopes: [
      { nominal: 106, mass: 105.9064599, abundance: 0.0125 },
      { nominal: 108, mass: 107.9041834, abundance: 0.0089 },
      { nominal: 110, mass: 109.90300661, abundance: 0.1249 },
      { nominal: 111, mass: 110.90418287, abundance: 0.128 },
      { nominal: 112, mass: 111.90276287, abundance: 0.2413 },
      { nominal: 113, mass: 112.90440813, abundance: 0.1222 },
      { nominal: 114, mass: 113.90336509, abundance: 0.2873 },
      { nominal: 116, mass: 115.90476315, abundance: 0.0749 },
    ],
    symbol: 'Cd',
    mass: 112.411557818268,
    name: 'Cadmium',
    monoisotopicMass: 113.90336509,
  },
  {
    number: 49,
    isotopes: [
      { nominal: 113, mass: 112.90406184, abundance: 0.0429 },
      { nominal: 115, mass: 114.903878776, abundance: 0.9571 },
    ],
    symbol: 'In',
    mass: 114.81808662944559,
    name: 'Indium',
    monoisotopicMass: 114.903878776,
  },
  {
    number: 50,
    isotopes: [
      { nominal: 112, mass: 111.90482387, abundance: 0.0097 },
      { nominal: 114, mass: 113.9027827, abundance: 0.0066 },
      { nominal: 115, mass: 114.903344699, abundance: 0.0034 },
      { nominal: 116, mass: 115.9017428, abundance: 0.1454 },
      { nominal: 117, mass: 116.90295398, abundance: 0.0768 },
      { nominal: 118, mass: 117.90160657, abundance: 0.2422 },
      { nominal: 119, mass: 118.90331117, abundance: 0.0859 },
      { nominal: 120, mass: 119.90220163, abundance: 0.3258 },
      { nominal: 122, mass: 121.9034438, abundance: 0.0463 },
      { nominal: 124, mass: 123.9052766, abundance: 0.0579 },
    ],
    symbol: 'Sn',
    mass: 118.71011259301059,
    name: 'Tin',
    monoisotopicMass: 119.90220163,
  },
  {
    number: 51,
    isotopes: [
      { nominal: 121, mass: 120.903812, abundance: 0.5721 },
      { nominal: 123, mass: 122.9042132, abundance: 0.4279 },
    ],
    symbol: 'Sb',
    mass: 121.75978367348,
    name: 'Antimony',
    monoisotopicMass: 120.903812,
  },
  {
    number: 52,
    isotopes: [
      { nominal: 120, mass: 119.9040593, abundance: 0.0009 },
      { nominal: 122, mass: 121.9030435, abundance: 0.0255 },
      { nominal: 123, mass: 122.9042698, abundance: 0.0089 },
      { nominal: 124, mass: 123.9028171, abundance: 0.0474 },
      { nominal: 125, mass: 124.9044299, abundance: 0.0707 },
      { nominal: 126, mass: 125.9033109, abundance: 0.1884 },
      { nominal: 128, mass: 127.90446128, abundance: 0.3174 },
      { nominal: 130, mass: 129.906222748, abundance: 0.3408 },
    ],
    symbol: 'Te',
    mass: 127.6031264846604,
    name: 'Tellurium',
    monoisotopicMass: 129.906222748,
  },
  {
    number: 53,
    isotopes: [{ nominal: 127, mass: 126.9044719, abundance: 1 }],
    symbol: 'I',
    mass: 126.9044719,
    name: 'Iodine',
    monoisotopicMass: 126.9044719,
  },
  {
    number: 54,
    isotopes: [
      { nominal: 124, mass: 123.905892, abundance: 0.000952 },
      { nominal: 126, mass: 125.9042983, abundance: 0.00089 },
      { nominal: 128, mass: 127.903531, abundance: 0.019102 },
      { nominal: 129, mass: 128.9047808611, abundance: 0.264006 },
      { nominal: 130, mass: 129.903509349, abundance: 0.04071 },
      { nominal: 131, mass: 130.90508406, abundance: 0.212324 },
      { nominal: 132, mass: 131.9041550856, abundance: 0.269086 },
      { nominal: 134, mass: 133.90539466, abundance: 0.104357 },
      { nominal: 136, mass: 135.907214484, abundance: 0.088573 },
    ],
    symbol: 'Xe',
    mass: 131.29276144779053,
    name: 'Xenon',
    monoisotopicMass: 131.9041550856,
  },
  {
    number: 55,
    isotopes: [{ nominal: 133, mass: 132.905451961, abundance: 1 }],
    symbol: 'Cs',
    mass: 132.905451961,
    name: 'Caesium',
    monoisotopicMass: 132.905451961,
  },
  {
    number: 56,
    isotopes: [
      { nominal: 130, mass: 129.9063207, abundance: 0.00106 },
      { nominal: 132, mass: 131.9050611, abundance: 0.00101 },
      { nominal: 134, mass: 133.90450818, abundance: 0.02417 },
      { nominal: 135, mass: 134.90568838, abundance: 0.06592 },
      { nominal: 136, mass: 135.90457573, abundance: 0.07854 },
      { nominal: 137, mass: 136.90582714, abundance: 0.11232 },
      { nominal: 138, mass: 137.905247, abundance: 0.71698 },
    ],
    symbol: 'Ba',
    mass: 137.3268916286322,
    name: 'Barium',
    monoisotopicMass: 137.905247,
  },
  {
    number: 57,
    isotopes: [
      { nominal: 138, mass: 137.9071149, abundance: 0.0008881 },
      { nominal: 139, mass: 138.9063563, abundance: 0.9991119 },
    ],
    symbol: 'La',
    mass: 138.90546887371266,
    name: 'Lanthanum',
    monoisotopicMass: 138.9063563,
  },
  {
    number: 58,
    isotopes: [
      { nominal: 136, mass: 135.90712921, abundance: 0.00185 },
      { nominal: 138, mass: 137.905991, abundance: 0.00251 },
      { nominal: 140, mass: 139.9054431, abundance: 0.8845 },
      { nominal: 142, mass: 141.9092504, abundance: 0.11114 },
    ],
    symbol: 'Ce',
    mass: 140.1157307378545,
    name: 'Cerium',
    monoisotopicMass: 139.9054431,
  },
  {
    number: 59,
    isotopes: [{ nominal: 141, mass: 140.9076576, abundance: 1 }],
    symbol: 'Pr',
    mass: 140.9076576,
    name: 'Praseodymium',
    monoisotopicMass: 140.9076576,
  },
  {
    number: 60,
    isotopes: [
      { nominal: 142, mass: 141.907729, abundance: 0.27152 },
      { nominal: 143, mass: 142.90982, abundance: 0.12174 },
      { nominal: 144, mass: 143.910093, abundance: 0.23798 },
      { nominal: 145, mass: 144.9125793, abundance: 0.08293 },
      { nominal: 146, mass: 145.9131226, abundance: 0.17189 },
      { nominal: 148, mass: 147.9168993, abundance: 0.05756 },
      { nominal: 150, mass: 149.9209022, abundance: 0.05638 },
    ],
    symbol: 'Nd',
    mass: 144.241596031827,
    name: 'Neodymium',
    monoisotopicMass: 141.907729,
  },
  { number: 61, isotopes: [], symbol: 'Pm', mass: null, name: 'Promethium' },
  {
    number: 62,
    isotopes: [
      { nominal: 144, mass: 143.9120065, abundance: 0.0307 },
      { nominal: 147, mass: 146.9149044, abundance: 0.1499 },
      { nominal: 148, mass: 147.9148292, abundance: 0.1124 },
      { nominal: 149, mass: 148.9171921, abundance: 0.1382 },
      { nominal: 150, mass: 149.9172829, abundance: 0.0738 },
      { nominal: 152, mass: 151.9197397, abundance: 0.2675 },
      { nominal: 154, mass: 153.9222169, abundance: 0.2275 },
    ],
    symbol: 'Sm',
    mass: 150.36635571193,
    name: 'Samarium',
    monoisotopicMass: 151.9197397,
  },
  {
    number: 63,
    isotopes: [
      { nominal: 151, mass: 150.9198578, abundance: 0.4781 },
      { nominal: 153, mass: 152.921238, abundance: 0.5219 },
    ],
    symbol: 'Eu',
    mass: 151.96437812637998,
    name: 'Europium',
    monoisotopicMass: 152.921238,
  },
  {
    number: 64,
    isotopes: [
      { nominal: 152, mass: 151.9197995, abundance: 0.002 },
      { nominal: 154, mass: 153.9208741, abundance: 0.0218 },
      { nominal: 155, mass: 154.9226305, abundance: 0.148 },
      { nominal: 156, mass: 155.9221312, abundance: 0.2047 },
      { nominal: 157, mass: 156.9239686, abundance: 0.1565 },
      { nominal: 158, mass: 157.9241123, abundance: 0.2484 },
      { nominal: 160, mass: 159.9270624, abundance: 0.2186 },
    ],
    symbol: 'Gd',
    mass: 157.25213064687998,
    name: 'Gadolinium',
    monoisotopicMass: 157.9241123,
  },
  {
    number: 65,
    isotopes: [{ nominal: 159, mass: 158.9253547, abundance: 1 }],
    symbol: 'Tb',
    mass: 158.9253547,
    name: 'Terbium',
    monoisotopicMass: 158.9253547,
  },
  {
    number: 66,
    isotopes: [
      { nominal: 156, mass: 155.9242847, abundance: 0.00056 },
      { nominal: 158, mass: 157.9244159, abundance: 0.00095 },
      { nominal: 160, mass: 159.9252046, abundance: 0.02329 },
      { nominal: 161, mass: 160.9269405, abundance: 0.18889 },
      { nominal: 162, mass: 161.9268056, abundance: 0.25475 },
      { nominal: 163, mass: 162.9287383, abundance: 0.24896 },
      { nominal: 164, mass: 163.9291819, abundance: 0.2826 },
    ],
    symbol: 'Dy',
    mass: 162.499472819424,
    name: 'Dysprosium',
    monoisotopicMass: 163.9291819,
  },
  {
    number: 67,
    isotopes: [{ nominal: 165, mass: 164.9303288, abundance: 1 }],
    symbol: 'Ho',
    mass: 164.9303288,
    name: 'Holmium',
    monoisotopicMass: 164.9303288,
  },
  {
    number: 68,
    isotopes: [
      { nominal: 162, mass: 161.9287884, abundance: 0.00139 },
      { nominal: 164, mass: 163.9292088, abundance: 0.01601 },
      { nominal: 166, mass: 165.9302995, abundance: 0.33503 },
      { nominal: 167, mass: 166.9320546, abundance: 0.22869 },
      { nominal: 168, mass: 167.9323767, abundance: 0.26978 },
      { nominal: 170, mass: 169.9354702, abundance: 0.1491 },
    ],
    symbol: 'Er',
    mass: 167.259082649669,
    name: 'Erbium',
    monoisotopicMass: 165.9302995,
  },
  {
    number: 69,
    isotopes: [{ nominal: 169, mass: 168.9342179, abundance: 1 }],
    symbol: 'Tm',
    mass: 168.9342179,
    name: 'Thulium',
    monoisotopicMass: 168.9342179,
  },
  {
    number: 70,
    isotopes: [
      { nominal: 168, mass: 167.9338896, abundance: 0.00123 },
      { nominal: 170, mass: 169.9347664, abundance: 0.02982 },
      { nominal: 171, mass: 170.9363302, abundance: 0.1409 },
      { nominal: 172, mass: 171.9363859, abundance: 0.2168 },
      { nominal: 173, mass: 172.9382151, abundance: 0.16103 },
      { nominal: 174, mass: 173.9388664, abundance: 0.32026 },
      { nominal: 176, mass: 175.9425764, abundance: 0.12996 },
    ],
    symbol: 'Yb',
    mass: 173.05415016631702,
    name: 'Ytterbium',
    monoisotopicMass: 173.9388664,
  },
  {
    number: 71,
    isotopes: [
      { nominal: 175, mass: 174.9407752, abundance: 0.97401 },
      { nominal: 176, mass: 175.9426897, abundance: 0.02599 },
    ],
    symbol: 'Lu',
    mass: 174.96681495785498,
    name: 'Lutetium',
    monoisotopicMass: 174.9407752,
  },
  {
    number: 72,
    isotopes: [
      { nominal: 174, mass: 173.9400461, abundance: 0.0016 },
      { nominal: 176, mass: 175.9414076, abundance: 0.0526 },
      { nominal: 177, mass: 176.9432277, abundance: 0.186 },
      { nominal: 178, mass: 177.9437058, abundance: 0.2728 },
      { nominal: 179, mass: 178.9458232, abundance: 0.1362 },
      { nominal: 180, mass: 179.946557, abundance: 0.3508 },
    ],
    symbol: 'Hf',
    mass: 178.4849787234,
    name: 'Hafnium',
    monoisotopicMass: 179.946557,
  },
  {
    number: 73,
    isotopes: [
      { nominal: 180, mass: 179.9474648, abundance: 0.0001201 },
      { nominal: 181, mass: 180.9479958, abundance: 0.9998799 },
    ],
    symbol: 'Ta',
    mass: 180.9478756362269,
    name: 'Tantalum',
    monoisotopicMass: 180.9479958,
  },
  {
    number: 74,
    isotopes: [
      { nominal: 180, mass: 179.9467108, abundance: 0.0012 },
      { nominal: 182, mass: 181.94820394, abundance: 0.265 },
      { nominal: 183, mass: 182.95022275, abundance: 0.1431 },
      { nominal: 184, mass: 183.95093092, abundance: 0.3064 },
      { nominal: 186, mass: 185.9543628, abundance: 0.2843 },
    ],
    symbol: 'W',
    mass: 183.841777550513,
    name: 'Tungsten',
    monoisotopicMass: 183.95093092,
  },
  {
    number: 75,
    isotopes: [
      { nominal: 185, mass: 184.9529545, abundance: 0.374 },
      { nominal: 187, mass: 186.9557501, abundance: 0.626 },
    ],
    symbol: 'Re',
    mass: 186.20670454560002,
    name: 'Rhenium',
    monoisotopicMass: 186.9557501,
  },
  {
    number: 76,
    isotopes: [
      { nominal: 184, mass: 183.9524885, abundance: 0.0002 },
      { nominal: 186, mass: 185.953835, abundance: 0.0159 },
      { nominal: 187, mass: 186.9557474, abundance: 0.0196 },
      { nominal: 188, mass: 187.9558352, abundance: 0.1324 },
      { nominal: 189, mass: 188.9581442, abundance: 0.1615 },
      { nominal: 190, mass: 189.9584437, abundance: 0.2626 },
      { nominal: 192, mass: 191.961477, abundance: 0.4078 },
    ],
    symbol: 'Os',
    mass: 190.22485962823998,
    name: 'Osmium',
    monoisotopicMass: 191.961477,
  },
  {
    number: 77,
    isotopes: [
      { nominal: 191, mass: 190.9605893, abundance: 0.373 },
      { nominal: 193, mass: 192.9629216, abundance: 0.627 },
    ],
    symbol: 'Ir',
    mass: 192.2160516521,
    name: 'Iridium',
    monoisotopicMass: 192.9629216,
  },
  {
    number: 78,
    isotopes: [
      { nominal: 190, mass: 189.9599297, abundance: 0.00012 },
      { nominal: 192, mass: 191.9610387, abundance: 0.00782 },
      { nominal: 194, mass: 193.9626809, abundance: 0.3286 },
      { nominal: 195, mass: 194.9647917, abundance: 0.3378 },
      { nominal: 196, mass: 195.96495209, abundance: 0.2521 },
      { nominal: 198, mass: 197.9678949, abundance: 0.07356 },
    ],
    symbol: 'Pt',
    mass: 195.084456864931,
    name: 'Platinum',
    monoisotopicMass: 194.9647917,
  },
  {
    number: 79,
    isotopes: [{ nominal: 197, mass: 196.96656879, abundance: 1 }],
    symbol: 'Au',
    mass: 196.96656879,
    name: 'Gold',
    monoisotopicMass: 196.96656879,
  },
  {
    number: 80,
    isotopes: [
      { nominal: 196, mass: 195.9658326, abundance: 0.0015 },
      { nominal: 198, mass: 197.9667686, abundance: 0.0997 },
      { nominal: 199, mass: 198.96828064, abundance: 0.1687 },
      { nominal: 200, mass: 199.96832659, abundance: 0.231 },
      { nominal: 201, mass: 200.97030284, abundance: 0.1318 },
      { nominal: 202, mass: 201.9706434, abundance: 0.2986 },
      { nominal: 204, mass: 203.97349398, abundance: 0.0687 },
    ],
    symbol: 'Hg',
    mass: 200.59916703455602,
    name: 'Mercury',
    monoisotopicMass: 201.9706434,
  },
  {
    number: 81,
    isotopes: [
      { nominal: 203, mass: 202.9723446, abundance: 0.2952 },
      { nominal: 205, mass: 204.9744278, abundance: 0.7048 },
    ],
    symbol: 'Tl',
    mass: 204.38341283936,
    name: 'Thallium',
    monoisotopicMass: 204.9744278,
  },
  {
    number: 82,
    isotopes: [
      { nominal: 204, mass: 203.973044, abundance: 0.014 },
      { nominal: 206, mass: 205.9744657, abundance: 0.241 },
      { nominal: 207, mass: 206.9758973, abundance: 0.221 },
      { nominal: 208, mass: 207.9766525, abundance: 0.524 },
    ],
    symbol: 'Pb',
    mass: 207.216908063,
    name: 'Lead',
    monoisotopicMass: 207.9766525,
  },
  {
    number: 83,
    isotopes: [{ nominal: 209, mass: 208.9803991, abundance: 1 }],
    symbol: 'Bi',
    mass: 208.9803991,
    name: 'Bismuth',
    monoisotopicMass: 208.9803991,
  },
  { number: 84, isotopes: [], symbol: 'Po', mass: null, name: 'Polonium' },
  { number: 85, isotopes: [], symbol: 'At', mass: null, name: 'Astatine' },
  { number: 86, isotopes: [], symbol: 'Rn', mass: null, name: 'Radon' },
  { number: 87, isotopes: [], symbol: 'Fr', mass: null, name: 'Francium' },
  { number: 88, isotopes: [], symbol: 'Ra', mass: null, name: 'Radium' },
  { number: 89, isotopes: [], symbol: 'Ac', mass: null, name: 'Actinium' },
  {
    number: 90,
    isotopes: [{ nominal: 232, mass: 232.0380558, abundance: 1 }],
    symbol: 'Th',
    mass: 232.0380558,
    name: 'Thorium',
    monoisotopicMass: 232.0380558,
  },
  {
    number: 91,
    isotopes: [{ nominal: 231, mass: 231.0358842, abundance: 1 }],
    symbol: 'Pa',
    mass: 231.0358842,
    name: 'Protactinium',
    monoisotopicMass: 231.0358842,
  },
  {
    number: 92,
    isotopes: [
      { nominal: 234, mass: 234.0409523, abundance: 0.000054 },
      { nominal: 235, mass: 235.0439301, abundance: 0.007204 },
      { nominal: 238, mass: 238.0507884, abundance: 0.992742 },
    ],
    symbol: 'U',
    mass: 238.0289104616574,
    name: 'Uranium',
    monoisotopicMass: 238.0507884,
  },
  { number: 93, isotopes: [], symbol: 'Np', mass: null, name: 'Neptunium' },
  { number: 94, isotopes: [], symbol: 'Pu', mass: null, name: 'Plutonium' },
  { number: 95, isotopes: [], symbol: 'Am', name: 'Americium', mass: null },
  { number: 96, isotopes: [], symbol: 'Cm', name: 'Curium', mass: null },
  { number: 97, isotopes: [], symbol: 'Bk', name: 'Berkelium', mass: null },
  { number: 98, isotopes: [], symbol: 'Cf', name: 'Californium', mass: null },
  { number: 99, isotopes: [], symbol: 'Es', name: 'Einsteinium', mass: null },
  { number: 100, isotopes: [], symbol: 'Fm', name: 'Fermium', mass: null },
  { number: 101, isotopes: [], symbol: 'Md', name: 'Mendelevium', mass: null },
  { number: 102, isotopes: [], symbol: 'No', name: 'Nobelium', mass: null },
  { number: 103, isotopes: [], symbol: 'Lr', name: 'Lawrencium', mass: null },
  {
    number: 104,
    isotopes: [],
    symbol: 'Rf',
    name: 'Rutherfordium',
    mass: null,
  },
  { number: 105, isotopes: [], symbol: 'Db', name: 'Dubnium', mass: null },
  { number: 106, isotopes: [], symbol: 'Sg', name: 'Seaborgium', mass: null },
  { number: 107, isotopes: [], symbol: 'Bh', name: 'Bohrium', mass: null },
  { number: 108, isotopes: [], symbol: 'Hs', name: 'Hassium', mass: null },
  { number: 109, isotopes: [], symbol: 'Mt', name: 'Meitnerium', mass: null },
  { number: 110, isotopes: [], symbol: 'Ds', name: 'Darmstadtium', mass: null },
  { number: 111, isotopes: [], symbol: 'Rg', name: 'Roentgenium', mass: null },
  { number: 112, isotopes: [], symbol: 'Cn', name: 'Copernicium', mass: null },
  { number: 113, isotopes: [], symbol: 'Nh', name: 'Nihonium', mass: null },
  { number: 114, isotopes: [], symbol: 'Fl', name: 'Flerovium', mass: null },
  { number: 115, isotopes: [], symbol: 'Mc', name: 'Moscovium', mass: null },
  { number: 116, isotopes: [], symbol: 'Lv', name: 'Livermorium', mass: null },
  { number: 117, isotopes: [], symbol: 'Ts', name: 'Teennessine', mass: null },
  { number: 118, isotopes: [], symbol: 'Og', name: 'Oganesson', mass: null },
];
